import { IStringTool } from "../core/IStringTool"

/**
 * Input for origin parser.
 * Supports static values or `random(...)` expressions.
 */
interface OriginInput {
  /** Raw origin string, e.g. `'center'` or `'random(top, bottom)'`. */
  value: string
}

/**
 * Tool that parses origin strings.
 * Allows static values like `'center'`, or expressions like `'random(...)'` to select one randomly.
 */
export default class OriginParserTool implements IStringTool<OriginInput, string> {
  /**
   * @returns Parsed string value (static or randomly chosen).
   */
  process({ value }: OriginInput): string {
    const raw = value.trim()

    if (raw.startsWith("random(") && raw.endsWith(")")) {
      const options = raw
        .slice(7, -1)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)

      const index = Math.floor(Math.random() * options.length)
      return options[index]
    }

    return raw
  }
}
